<template>
    <div>
        <!--        DON'T FORGET PREVIEW FUNCTIONALITY-->
        <design-2021-assignment-show-title-buttons-component
            :project-in="projectIn"
            :is-preview="isPreview"
            :assignment-in="assignment"
            :view-type="viewType"
            :group-id-in="groupIdIn"
            :groupIn="groupIn"
            :selected-sub-assignment-id="selectedSubAssignmentId"
            :students-in="projectIn ? projectIn.students : []"
            @assignmentPartnerRemoved="removePartner($event)"
            @updatedViewType="updateViewType">
        </design-2021-assignment-show-title-buttons-component>

        <design-2021-assignment-edit-evaluate-modal
            v-if="projectIn"
            :evaluate-in="evaluateIn"
            :users-in="usersIn"
            :assignment-in="assignmentIn"
            :project-id="projectIn.id">
        </design-2021-assignment-edit-evaluate-modal>

        <design-2021-assignment-show-feedback-component
            v-if="projectIn && assignment && assignment.hasFeedback()"
            :feedback-in="assignment.feedback"
            :project-id="projectIn.id"
            :assignment-in="assignment">
        </design-2021-assignment-show-feedback-component>

        <div
            class="row"
            v-if="assignment">
            <div
                class="col-12 col-md-4 col-xl-3 assignment-sidebar"
                v-if="assignment.sub_assignments.length > 1 || assignmentHasDeadline()">
                <design-2021-assignment-show-deadline-component
                    v-if="projectIn"
                    :assignment-in="assignment">
                </design-2021-assignment-show-deadline-component>

                <design-2021-assignment-show-nav-component
                    v-if="assignment.sub_assignments.length > 1"
                    :selected-view-in="viewType"
                    :assignment-in="assignment"
                    :selected-page-id-in="selectedPageId"
                    :selected-sub-assignment-id-in="selectedSubAssignmentId"
                    @selected-sub-assignment="setSelectedSubAssignment($event)"
                    @selected-page="setSelectedPage($event)">
                </design-2021-assignment-show-nav-component>
            </div>

            <div
                class="assignment-content"
                v-if="selectedSubAssignment"
                :class="
                    assignment.sub_assignments.length === 1 && !assignmentHasDeadline()
                        ? 'col-12'
                        : 'col-12 col-md-8 col-xl-9'
                ">
                <design-2021-assignment-show-sub-assignment-component
                    :assignment-in="assignment"
                    :group-id-in="groupIdIn"
                    :group-type-id-in="groupIn ? groupTypeIdIn : 7"
                    :assignment-id-in="assignment.id"
                    :profile-categories-in="profileCategoriesIn"
                    :sub-assignment-in="selectedSubAssignment"
                    :selected-page-id-in="selectedPageId"
                    :selected-sub-assignment-id-in="selectedSubAssignmentId"
                    :project-id="projectIn ? projectIn.id : null"
                    :is-example-in="isPreview"
                    :assignment-status-in="assignment.getStatus()"
                    @selected-page="setSelectedPage($event)"
                    @submitted="submitted"
                    :view-type="viewType">
                </design-2021-assignment-show-sub-assignment-component>
            </div>
        </div>
    </div>
</template>

<script>
    import { ords } from '../../../app';

    const assignmentOrds = ords.use('assignment');
    export default {
        name: 'design-2021-assignment-show-component',
        props: {
            assignmentIn: Object,
            profileCategoriesIn: {
                type: Array,
                default: () => []
            },
            evaluateIn: Object,
            usersIn: String,
            projectIn: {
                type: Object,
                default: null
            },
            groupIn: Object,
            groupIdIn: Number,
            isPreview: {
                type: Boolean,
                default: false
            },
            groupTypeIdIn: {
                type: Number,
                required: false,
                default: null
            }
        },
        data() {
            return {
                assignment: null,
                selectedSubAssignmentId: null,
                selectedPageId: null,
                viewType: this.$authUser.isTeacher() ? 1 : 2,
                userType: this.$authUser.isTeacher() ? 2 : this.$authUser.isAdmin() ? 1 : 3,
                groupTypeId: this.groupIdIn ? this.groupIdIn.type_id : this.groupTypeIdIn
            };
        },
        computed: {
            selectedSubAssignment() {
                for (const subAssignment of this.assignment.sub_assignments) {
                    if (subAssignment.id === this.selectedSubAssignmentId) {
                        return subAssignment;
                    }
                }
                return null;
            }
        },
        methods: {
            setSelectedSubAssignment(id) {
                this.selectedSubAssignmentId = id;
                this.updateSelectedSubAssignmentStorage(id);

                this.setSelectedPage(this.selectedSubAssignment.pages[0].id);
            },
            setSelectedPage(id) {
                this.selectedPageId = id;
                this.updateSelectedPageStorage(id);
            },
            updateSelectedSubAssignmentStorage(id) {
                const name = 'assignment-show-selected-sub-assignment-' + this.assignmentIn.id;
                localStorage.setItem(name, id);
            },
            updateSelectedPageStorage(id) {
                const name = 'assignment-show-selected-page-' + this.assignmentIn.id;
                localStorage.setItem(name, id);
            },
            submitted(type) {
                let checked = false;

                for (let i = 0; i < this.assignment.sub_assignments.length; i++) {
                    const subAssignment = this.assignment.sub_assignments[i];

                    if (checked) {
                        if (!subAssignment.hasStatus() || subAssignment.getStatus().isWaitingForSubmit()) {
                            this.setSelectedSubAssignment(subAssignment.id);
                            this.alert.success();
                            return;
                        }
                    } else if (subAssignment.id === this.selectedSubAssignmentId) {
                        if (this.assignment.sub_assignments.length === i - 1) {
                            break;
                        }
                        checked = true;
                    }
                }

                for (let i = 0; i < this.assignment.sub_assignments.length; i++) {
                    const subAssignment = this.assignment.sub_assignments[i];
                    // if (subAssignment.id === this.selectedSubAssignmentId) {
                    //     this.alert.notice('Alles ingeleverd', 'Alle deelopdrachten zijn ingeleverd!')
                    //     return;
                    // }

                    if (!subAssignment.hasStatus() || subAssignment.getStatus().isWaitingForSubmit()) {
                        this.setSelectedSubAssignment(subAssignment.id);
                        this.alert.success();
                        return;
                    }
                }

                this.alert.success();
            },
            updateViewType(viewId) {
                this.viewType = viewId;
                const name = 'assignment-show-view-type';
                localStorage.setItem(name, viewId);

                const userTypeName = 'assignment-show-user-type';
                localStorage.setItem(userTypeName, this.userType);
            },

        assignmentHasDeadline() {
                if (this.assignmentIn.deadlines?.length > 0) {
                return true;
                }

                if (this.assignmentIn.sub_assignments.length > 0) {
                    this.assignmentIn.sub_assignments.forEach((subAssignment) => {
                    return subAssignment.deadlines?.length > 0;
                    });
                }

            return false;
        },
        },
        mounted() {
            // todo portfolio Rating results prevents observable rating
            if (!assignmentOrds.findStatic(this.assignmentIn.id)) {
                assignmentOrds.add(this.assignmentIn);
            }

            assignmentOrds
                .with('statuses', (statusCallback) => {
                    statusCallback.with('activities', (activityCallback) => {
                        activityCallback.with('user');
                    });
                })
                .with(['deadlines'])
                .with('feedback', (feedbackCallBack) => {
                    feedbackCallBack.with('user', (userCallback) => {
                        userCallback.with('profile_image', (fileCallback) => {
                            fileCallback.with('file');
                        });
                    });
                })
                .with('assignment_cooperations', (assignmentCooperationCallback) => {
                    assignmentCooperationCallback.with('assignment_partners', (assignmentPartnerCallback) => {
                        assignmentPartnerCallback.with('assignment_partner_users', (assignmentPartnerUsersCallback) => {
                            assignmentPartnerUsersCallback.with('user');
                        });
                    });
                })
                .with('portfolio_rating', (assignmentPortfolioRatingCallback) => {
                    assignmentPortfolioRatingCallback.with('results');
                })

                .with('sub_assignments', (callback) => {
                    callback
                        .orderBy('order')
                        .with('deadlines')
                        .with('statuses', (statusCallback) => {
                            statusCallback.with('activities', (activityCallback) => {
                                activityCallback.with('user');
                            });
                        })
                        .with('feedback', (feedbackCallback) => {
                            feedbackCallback.with('user');
                        })
                        .with('pages', (pagesCallback) => {
                            pagesCallback.orderBy('order');
                            pagesCallback.with('parts', (partsCallback) => {
                                partsCallback.orderBy('order');
                                partsCallback.with(['text', 'video_link', 'part_files', 'list_items', 'list_options']);
                                partsCallback.with('answers', (answerCallback) => {
                                    answerCallback.with(['text', 'files', 'list_items', 'list_checks', 'json']);
                                });

                                //todo temp relation until ords update
                                partsCallback.with('page', (npCallback) => {
                                    npCallback.with('sub_assignment', (saCallback) => {
                                        saCallback.with('pages', (nestedPagesCallback) => {
                                            nestedPagesCallback.orderBy('order');
                                            nestedPagesCallback.with('parts');
                                        });
                                    });
                                });
                            });
                        })
                        .with('assignment', (assignmentCallback) => {
                            // todo doesn't work
                            assignmentCallback.with('statuses');
                        })
                        .with('portfolio_rating', (subAssignmentPortfolioRatingCallback) => {
                            subAssignmentPortfolioRatingCallback.with('results');
                        })

                        .with('assignment_cooperations', (assignmentCooperationCallback) => {
                            assignmentCooperationCallback.with('assignment_partners', (assignmentPartnerCallback) => {
                                assignmentPartnerCallback.with(
                                    'assignment_partner_users',
                                    (assignmentPartnerUsersCallback) => {
                                        assignmentPartnerUsersCallback.with('user');
                                    }
                                );
                            });
                        });
                })
                .find(this.assignmentIn.id)
                .subscribe((assignment) => {
                    this.assignment = assignment;
                });

            const userKey = 'assignment-show-user-type';
            let userId = 0;
            if (localStorage.getItem(userKey) && localStorage.getItem(userKey) !== 'null') {
                userId = parseInt(localStorage.getItem(userKey));
            }

            let selectedSubAssignment = null;
            const subAssignmentKey = 'assignment-show-selected-sub-assignment-' + this.assignment.id;
            if (
                localStorage.getItem(subAssignmentKey) &&
                localStorage.getItem(subAssignmentKey) !== 'null' &&
                userId === this.userType
            ) {
                let id = parseInt(localStorage.getItem(subAssignmentKey));

                for (const subAssignment of this.assignment.sub_assignments) {
                    if (subAssignment.id === id) {
                        this.selectedSubAssignmentId = id;
                        selectedSubAssignment = subAssignment;
                        break;
                    }
                }
                if (!this.selectedSubAssignmentId) {
                    this.selectedSubAssignmentId = this.assignment.sub_assignments[0].id;
                    selectedSubAssignment = this.assignment.sub_assignments[0];
                    this.updateSelectedSubAssignmentStorage(this.selectedSubAssignmentId);
                }
            } else {
                this.selectedSubAssignmentId = this.assignment.sub_assignments[0].id;
                selectedSubAssignment = this.assignment.sub_assignments[0];
                this.updateSelectedSubAssignmentStorage(this.selectedSubAssignmentId);
            }

            const pageKey = 'assignment-show-selected-page-' + this.assignment.id;
            const pages = selectedSubAssignment.pages;

            if (localStorage.getItem(pageKey) && localStorage.getItem(pageKey) !== 'null' && userId === this.userType) {
                let key = localStorage.getItem(pageKey);

                for (const page of pages) {
                    if (parseInt(page.id) === parseInt(key)) {
                        this.selectedPageId = page.id;
                        break;
                    }
                }

                if (!this.selectedPageId) {
                    this.selectedPageId = pages[0].id;
                    this.updateSelectedPageStorage(this.selectedPageId);
                }
            } else {
                this.selectedPageId = pages[0].id;
                this.updateSelectedPageStorage(this.selectedPageId);
            }

            const name = 'assignment-show-view-type';
            if (localStorage.getItem(name) && localStorage.getItem(name) !== 'null' && userId === this.userType) {
                this.updateViewType(parseInt(localStorage.getItem(name)));
            } else {
                this.updateViewType(this.$authUser.isTeacher() ? 1 : 2);
            }
        }
    };
</script>

<style scoped lang="scss">
    .assignment-content {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .assignment-nav {
        margin-bottom: 45px;
    }

    .alert-feedback {
        margin-bottom: 30px;
    }

    @media (min-width: map-get($grid-breakpoints, 'md')) {
        .assignment-content {
            margin-top: 0;
        }
    }
</style>
